"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = exports.LoaderDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var react_spinners_1 = require("react-spinners");
exports.LoaderDefaultProps = {
  spinnerColor: 'primary',
  spinnerSize: 8,
  message: 'Please wait...',
  spaceUnits: 4,
  inverted: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    font-family: ", ";\n    flex-direction: column;\n  "], ["\n    display: flex;\n    align-items: center;\n    font-family: ", ";\n    flex-direction: column;\n  "])), theme_1.theme.FONT('sans')),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: row;\n    align-items: center;\n  "], ["\n    flex-direction: row;\n    align-items: center;\n  "])))
});
var SpinnerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-shrink: 0;\n  "], ["\n    flex-shrink: 0;\n  "])))
});
var MessageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: ", ";\n    font-weight: 500;\n    color: ", ";\n\n    ", "\n  "], ["\n    margin-top: ", ";\n    font-weight: 500;\n    color: ", ";\n\n    ", "\n  "])), theme_1.theme.UNIT(4), theme_1.theme.COLOR('text-mid'), function (props) {
    return props.inverted && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme_1.theme.COLOR('light'));
  }),
  tablet: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n    margin-top: 0px;\n  "], ["\n    ", "\n    margin-top: 0px;\n  "])), function (_a) {
    var spaceUnits = _a.spaceUnits;
    return spaceUnits && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), theme_1.theme.UNIT(spaceUnits));
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Spinner: (0, styled_components_1.default)(react_spinners_1.ClipLoader)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), SpinnerStyles),
  Message: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), MessageStyles)
};
var LoaderComponent = function (props) {
  var className = props.className,
    children = props.children,
    message = props.message,
    spinnerSize = props.spinnerSize,
    spaceUnits = props.spaceUnits,
    inverted = props.inverted;
  // theme functions return a function to evaluate the theme value on a theme object (passed in via context) 
  var spinnerColor = theme_1.theme.COLOR(props.spinnerColor)(props);
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.Spinner, {
    size: spinnerSize,
    color: spinnerColor
  }), React.createElement(My.Message, {
    inverted: inverted,
    spaceUnits: spaceUnits
  }, children || message));
};
LoaderComponent.defaultProps = exports.LoaderDefaultProps;
// note, we internalize the React component, and always export Loader wrapped in the withTheme HOC
// (the HOC is required for the theme coloring to work)
exports.Loader = (0, styled_components_1.withTheme)(LoaderComponent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;